import { NgModule } from '@angular/core'

import { PhonePipe } from './phone.pipe'
import { FeetAndInchesPipe } from './feet-and-inches.pipe'
import { WordsPipe } from './words.pipe'

@NgModule({
  declarations: [FeetAndInchesPipe, PhonePipe, WordsPipe],
  imports: [],
  exports: [FeetAndInchesPipe, PhonePipe, WordsPipe],
  providers: [FeetAndInchesPipe, PhonePipe, WordsPipe],
})
export class PipesModule {}
